import { FC, useContext } from 'react'
import './Addons.css'
import { Icon } from '../../Icon/Icon'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'

export const ZoomControls: FC = observer(() => {
  const store = useContext(StoreContext)
  const { zoomButtons } = store.TranslationsState.translations

  return (
    <div className="pdf-addons__navigation onboarding-pdf-viewer-navigation">
      <div className="pdf-addons__navigation-inner onboarding-pdf-viewer-navigation-inner">
        <button
          className="pdf-addons__zoom-button"
          onClick={() => store.PdfViewerState.zoomOut()}
          tabIndex={0}
          aria-label={zoomButtons.zoomOut}
        >
          <Icon type="zoom-out" size="30px" />
        </button>

        <button
          className="pdf-addons__zoom-button"
          onClick={() => store.PdfViewerState.zoomIn()}
          tabIndex={0}
          aria-label={zoomButtons.zoomIn}
        >
          <Icon type="zoom-in" size="30px" />
        </button>
      </div>
    </div>
  )
})
